const translations = {
    createInvoice: 'Create Invoice',
    delete: 'Delete',
    duplicate: 'Duplicate',
    edit: 'Edit',
    view: 'View'
};

export default translations;
